import instance from "../api/instance";
import { logout } from "./sessionActions";
import {
  GET_NOTIFICATION,
  CLEAR_NOTIFICATION,
  CLEAR_NOTIFICATIONS,
  GET_ALL_NOTIFICATIONS,
  GET_NOTIFICATION_TYPES,
} from "../constants/constants";

import { getFilters, queryString } from '../../components/utils/functions';

export const getAllNotifications = (page = 0, size = 10, filters = [], admission = false, sort = 'id,DESC') => {
  if(admission === true) { filters.unshift({ property: "pendingChange", operator: "eq", value: "true" }); }
  var searchFilters = getFilters(filters);
  var queryFilters = [{ property: "sort", value: sort }];

  if (searchFilters !== '') {
    queryFilters.push({ property: "search", value: searchFilters });
  }

  return (dispatch) => {
    return instance
      .get(`/type-notification-emails/type-notification-email?page=${page}&size=${size}&${queryString(queryFilters)}`)
      .then((response) => dispatch({ type: GET_ALL_NOTIFICATIONS, payload: response.data.data }) )
      .catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 400:
              return Promise.reject(err);
          case 401: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
          case 500: // Deslogueamos porque el token es inválido
            return Promise.reject(err);
        }
      });
  };
};

export const getNotificationById = (id) => {
  return (dispatch) => {
    return instance.get(`/v1/type-notification-emails/type-notification-email/${id}`)
      .then((response) => {
        dispatch({ type: GET_NOTIFICATION, payload: response.data.data });
        return response.data;
      })
      .catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
          case 500: // Deslogueamos porque el token es inválido
            return Promise.reject(err);
        }
      });
  };
};

export const getNotificationsType = () => {
  return (dispatch) => {
    return instance
      .get(`/notification-emails/types`)
      .then((response) => dispatch({ type: GET_NOTIFICATION_TYPES, payload: response.data.data }) )
      .catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
          case 500: // Deslogueamos porque el token es inválido
            return Promise.reject(err);
        }
      });
  };
};

export const clearNotification = () => {
  return dispatch => dispatch({
    type: CLEAR_NOTIFICATION
  });
}

export const clearNotifications = () => {
  return dispatch => dispatch({
    type: CLEAR_NOTIFICATIONS
  });
}